module.exports = __webpack_public_path__ + "static/media/aura.df53fda3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/aura.svg
// module id = 296
// module chunks = 0